/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PlaceType } from './PlaceType';
import {
    PlaceTypeFromJSON,
    PlaceTypeFromJSONTyped,
    PlaceTypeToJSON,
    PlaceTypeToJSONTyped,
} from './PlaceType';
import type { Place } from './Place';
import {
    PlaceFromJSON,
    PlaceFromJSONTyped,
    PlaceToJSON,
    PlaceToJSONTyped,
} from './Place';

/**
 * 
 * @export
 * @interface OfferRequestSlice
 */
export interface OfferRequestSlice {
    /**
     * The [ISO 8601](https://en.wikipedia.org/wiki/ISO_8601) date on which the passengers want to depart
     * @type {Date}
     * @memberof OfferRequestSlice
     */
    departureDate?: Date;
    /**
     * The city or airport the passengers want to travel to
     * @type {Place}
     * @memberof OfferRequestSlice
     */
    destination?: Place;
    /**
     * 
     * @type {PlaceType}
     * @memberof OfferRequestSlice
     */
    destinationType?: PlaceType;
    /**
     * The city or airport the passengers want to depart from
     * @type {Place}
     * @memberof OfferRequestSlice
     */
    origin?: Place;
    /**
     * 
     * @type {PlaceType}
     * @memberof OfferRequestSlice
     */
    originType?: PlaceType;
}



/**
 * Check if a given object implements the OfferRequestSlice interface.
 */
export function instanceOfOfferRequestSlice(value: object): value is OfferRequestSlice {
    return true;
}

export function OfferRequestSliceFromJSON(json: any): OfferRequestSlice {
    return OfferRequestSliceFromJSONTyped(json, false);
}

export function OfferRequestSliceFromJSONTyped(json: any, ignoreDiscriminator: boolean): OfferRequestSlice {
    if (json == null) {
        return json;
    }
    return {
        
        'departureDate': json['departure_date'] == null ? undefined : (new Date(json['departure_date'])),
        'destination': json['destination'] == null ? undefined : PlaceFromJSON(json['destination']),
        'destinationType': json['destination_type'] == null ? undefined : PlaceTypeFromJSON(json['destination_type']),
        'origin': json['origin'] == null ? undefined : PlaceFromJSON(json['origin']),
        'originType': json['origin_type'] == null ? undefined : PlaceTypeFromJSON(json['origin_type']),
    };
}

export function OfferRequestSliceToJSON(json: any): OfferRequestSlice {
    return OfferRequestSliceToJSONTyped(json, false);
}

export function OfferRequestSliceToJSONTyped(value?: OfferRequestSlice | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'departure_date': value['departureDate'] == null ? value['departureDate'] : value['departureDate'].toISOString().substring(0,10),
        'destination': PlaceToJSON(value['destination']),
        'destination_type': PlaceTypeToJSON(value['destinationType']),
        'origin': PlaceToJSON(value['origin']),
        'origin_type': PlaceTypeToJSON(value['originType']),
    };
}

